<template>
  <div class="main">
    <div id="listview">
    <div v-for="item in items" :key="item.text" class="card">
      <div class="no-gutters" v-on:click="toDetails(item)">
        <img v-bind:src="item[13]" class="float-left" height=90 width=120 alt="...">
        <div class="card-body">
          <h6 class="card-title">{{item[1]}}</h6>
          <h6 class="card-subtitle mb-2 text-muted">{{item[5]}}<br><small class="text-muted pull-right">{{item[4]}}</small></h6>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import sx from '../utils/core.js'
// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  created () {
    this.$store.state.title = 'コース情報'
    this.$store.state.pageBack = 'Course'
  },
  data() {
    return {
      items: [],
      searchOpt: {
        kbn: '00',
        category: '19'
      }
    }
  },
  mounted() {
    $('#navbarSupportedContent').collapse({
      toggle: false
    }).collapse('hide')
    sx.showWaiting()
    const that = this

    var url = that.$store.state.baseurl + '/app/cmshelper/fetchPostList'
    var params = {
      bucketid: '17',
      options: JSON.stringify(that.searchOpt),
      token: localStorage.getItem('token')
    }
    sx.request(
      url,
      params,
      function(result) {
        if (result.status === 'ok') {
          $.each(result.data.rows, function(index, row) {
            var metadata = JSON.parse(row[10] || '{}')
            if (metadata.gallery && metadata.gallery.length > 0 && !sx.isNothingOrEmpty(metadata.gallery[0])) {
              row.push(that.$store.state.baseurl + metadata.gallery[0])
            }
            that.items.push(row)
          });
          sx.hideWaiting()
        } else {
          sx.toastSuccess(result.message)
          console.log(result.message)
        }
      },
      function() {
        sx.login(
          url,
          params,
          function(result) {
            if (result.status === 'ok') {
              that.items = result.data.rows
              sx.hideWaiting()
            } else {
              sx.toastSuccess(result.message)
              console.log(result.message)
            }
          }
        )
      }
    )
  },
  methods: {
    toDetails(item) {
      localStorage.setItem('itemDetails', JSON.stringify(item))
      this.$router.replace({ name: 'Details' })
    }
  }
}
</script>
<style scoped>
#listview {
   margin:4px;
}
#listview .card{
  text-align:left;
  margin-top:6px;
}
small {
  color:#fb6e14;
}

img {
  margin:2px 4px 2px 2px;
}
.lead{
  padding-top:20px;
  text-align:left;
  color:#fb6e14;
}
.main{
  padding:4px;
}
</style>
